<template>
  <svg fill="none" height="20" viewBox="0 0 18 20" width="18" xmlns="http://www.w3.org/2000/svg"><g stroke="#c5a75a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m15.75 19h-13.5c-.19891 0-.38968-.079-.53033-.2197-.14065-.1406-.21967-.3314-.21967-.5303v-16.5c0-.19891.07902-.38968.21967-.53033s.33142-.21967.53033-.21967h9l5.25 5.25v12c0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197z"/><path d="m11.25 1v5.25h5.25"/><path d="m6.375 12.625 2.625 2.625 2.625-2.625"/><path d="m9 9.25v6"/></g></svg>
</template>

<script>
  export default {}
</script>
